import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import QuarterGrid from './components/QuarterGrid'
import { apiURL } from '../../../utilities/URLs'
import { account } from '../../../classes/Account'
import { refreshAccessToken } from '../../../utilities/extensions'
import { getQuarterTiles } from '../../../utilities/quarterConfig'

export default function QuarterBreakdownPage() {
  const { applicationId } = useParams()
  const [pendingHoldQuarters, setPendingHoldQuarters] = useState(() => new Set())
  const [tiles, setTiles] = useState(() => getQuarterTiles('941-X'))

  useEffect(() => {
    let cancelled = false

    const loadFormType = async () => {
      const url = `${apiURL}/api/applications/${applicationId}/form-type/`
      const res = await fetch(url, { headers: { Authorization: account.accessToken } })
      const data = await res.json()
      if (cancelled) return
      if (data.response?.error === 'Failed To Authenticate Token.') {
        const refreshed = await refreshAccessToken()
        if (refreshed && !cancelled) loadFormType()
        return
      }
      if (!data.response?.error)
        setTiles(getQuarterTiles(data.response.formType))
    }

    const loadPendingHolds = async () => {
      const url = `${apiURL}/api/applications/${applicationId}/transcript-review-holds`
      const res = await fetch(url, { headers: { Authorization: account.accessToken } })
      const data = await res.json()
      if (cancelled) return
      if (data.response?.error === 'Failed To Authenticate Token.') {
        const refreshed = await refreshAccessToken()
        if (refreshed && !cancelled) loadPendingHolds()
        return
      }
      const keys = (data.response?.pending || []).map((p) => p.quarterKey)
      setPendingHoldQuarters(new Set(keys))
    }

    loadFormType()
    loadPendingHolds()
    return () => { cancelled = true }
  }, [applicationId])

  return (
    <div className='w-full flex justify-center p-4 sm:p-8 xl:p-12 transition-colors duration-300'>
      <div className='w-full h-full flex flex-col'>
        <div className='mb-8'>
          <h1 className='text-3xl font-bold text-slate-900 dark:text-white mb-3'>Quarter Breakdown</h1>
          <p className='text-slate-600 dark:text-slate-300'>View a breakdown of each quarter, including statuses and todo's.</p>
        </div>
        <div className='w-full grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
          {tiles.map((tile) => (
            <QuarterGrid
              key={tile.quarter}
              title={tile.title}
              quarter={tile.quarter}
              pendingTranscriptHold={pendingHoldQuarters.has(tile.quarter)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
